import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, FormControl, InputLabel, Select, MenuItem, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { apiRequest } from '../../../utils/fetch';
import { CurrencyInterface, GenericResponseInterface } from '../../../interfaces/interfaces';

const initialCurrency: Partial<CurrencyInterface> = {
  code: '',
  name: '',
  active: true,
};

const CurrenciesAdminAddCurrencyPage: React.FC = () => {
  const [currency, setCurrency] = useState<Partial<CurrencyInterface>>(initialCurrency);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (field: keyof CurrencyInterface, value: any) => {
    setCurrency(a => ({ ...a, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const result = await apiRequest<GenericResponseInterface<CurrencyInterface>>('/currencies/insert', 'POST', currency);
      if (result.status) {
        setSuccess(result.message || 'Currency created successfully!');
        setDialogOpen(true);
        setCurrency(initialCurrency);
      } else {
        setError(result.message || 'Failed to create currency');
        setDialogOpen(true);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to create currency');
      setDialogOpen(true);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>Add New Currency</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Code"
          value={currency.code ?? ''}
          onChange={e => handleChange('code', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Name"
          value={currency.name ?? ''}
          onChange={e => handleChange('name', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="active-label">Active</InputLabel>
          <Select
            labelId="active-label"
            value={currency.active !== undefined ? (currency.active ? 'yes' : 'no') : 'yes'}
            label="Active"
            onChange={e => handleChange('active', e.target.value === 'yes')}
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary">
            Create Currency
          </Button>
        </Box>
      </form>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{success ? 'Success' : 'Error'}</DialogTitle>
        <DialogContent>
          <Typography>{success || error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default CurrenciesAdminAddCurrencyPage;